var map = {
	"./layouts/auth-layout/auth-layout.module": [
		"./src/app/layouts/auth-layout/auth-layout.module.ts",
		"layouts-auth-layout-auth-layout-module"
	],
	"./pages/agents/agents.module": [
		"./src/app/pages/agents/agents.module.ts",
		"default~pages-agents-agents-module~pages-forms-forms-module",
		"pages-agents-agents-module"
	],
	"./pages/calendar/calendar.module": [
		"./src/app/pages/calendar/calendar.module.ts",
		"default~pages-calendar-calendar-module~pages-widgets-widgets-module",
		"default~pages-calendar-calendar-module~pages-components-components-module",
		"pages-calendar-calendar-module"
	],
	"./pages/charts/charts.module": [
		"./src/app/pages/charts/charts.module.ts",
		"default~pages-charts-charts-module~pages-dashboards-admin-dashboards-module~pages-widgets-widgets-module",
		"default~pages-charts-charts-module~pages-dashboards-admin-dashboards-module",
		"pages-charts-charts-module"
	],
	"./pages/components/components.module": [
		"./src/app/pages/components/components.module.ts",
		"default~pages-calendar-calendar-module~pages-components-components-module",
		"pages-components-components-module"
	],
	"./pages/dashboards-admin/dashboards.module": [
		"./src/app/pages/dashboards-admin/dashboards.module.ts",
		"default~pages-charts-charts-module~pages-dashboards-admin-dashboards-module~pages-widgets-widgets-module",
		"default~pages-charts-charts-module~pages-dashboards-admin-dashboards-module",
		"pages-dashboards-admin-dashboards-module"
	],
	"./pages/dashboards/dashboards.module": [
		"./src/app/pages/dashboards/dashboards.module.ts",
		"pages-dashboards-dashboards-module"
	],
	"./pages/forms/forms.module": [
		"./src/app/pages/forms/forms.module.ts",
		"default~pages-agents-agents-module~pages-forms-forms-module",
		"pages-forms-forms-module"
	],
	"./pages/maps/maps.module": [
		"./src/app/pages/maps/maps.module.ts",
		"pages-maps-maps-module"
	],
	"./pages/tables/tables.module": [
		"./src/app/pages/tables/tables.module.ts",
		"pages-tables-tables-module"
	],
	"./pages/widgets/widgets.module": [
		"./src/app/pages/widgets/widgets.module.ts",
		"default~pages-charts-charts-module~pages-dashboards-admin-dashboards-module~pages-widgets-widgets-module",
		"default~pages-calendar-calendar-module~pages-widgets-widgets-module",
		"pages-widgets-widgets-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;